import { messaging } from 'lib/axios';
import { useQuery } from 'react-query';

export const getConversationMessages = ({ conversationId }) => {
  return messaging.get(`/messages/${conversationId}`);
};

export const useConversationMessages = ({ conversationId, config } = {}) => {
  return useQuery({
    ...config,
    enabled: !!conversationId, // ✅ only fetch when conversationId is defined
    queryKey: [conversationId, 'conversation_messages'],
    queryFn: () => getConversationMessages({ conversationId }), // ✅ pass correctly
  });
};
